<template>
   <div class="yk-choice-question yk-choice-question-s-new">
       <el-form ref="form" :model="form" label-width="80px">
           <div class="yk-question">
                <el-form-item label="题型：" class='yk-question-type'>
                    <el-select placeholder="选择题型" v-model="numType" @change="changeType">
                        <el-option v-for="item in form.queType" :key="item.value" :label="item.label" :value="item.value">
                       </el-option>
                   </el-select>
               </el-form-item>
               <el-form-item label="难度：" class='yk-difficulty'>
                    <el-select v-model="diffTypeValue">
                        <el-option v-for="item in form.diffType" :key="item.value" :label="item.label" :value="item.value">
                       </el-option>
                   </el-select>
              </el-form-item>
           </div>
           <el-form-item :label="numType!=6?'题目':'题干'" class='yk-title'>
                <Editor v-model="stemContent" placeholder="请输入题干"/>
           </el-form-item>
           <el-form-item :label="numType!=6?'题目附件':'题干附件'" class='yk-attachment'>
                  <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList"></QuestionFile>
           </el-form-item>
            <!-- 单选 -->
           <el-form-item  class="yk-radioChoice" v-if="numType == 1">
              <div class='clearfix'>
                <div class='lf'>
                  <span>选项</span>
                </div>
                <div class='rt'>
                  <el-form-item  v-show="numType == 1|| numType == 2">
                    <el-button type="primary" @click="addChoice(numType)" icon='el-icon-circle-plus-outline'>添加选项</el-button>
                  </el-form-item>
                </div>
              </div>
               <div class="yk-op-choice-child" v-for="(item,index) in form.radioData" :key="index+1">
                    <el-radio >{{indexArr[index]}}</el-radio>
                    <div class="yk-input-show">
                      <!-- <el-input v-model="form.radioData[index]" placeholder="请输入内容" ></el-input> -->
                      <Editor v-model="form.radioData[index]" :config="editorconfig"/>
                      <!-- <Editor v-model="form.radioData[index]" height="42px" isShowMenus="false"/> -->
                    </div>
                    <el-radio-group v-model="form.radio" v-if='form.radio===index'>
                       <el-radio-button  :label="index" size="medium">正确答案</el-radio-button>
                    </el-radio-group>
                    <el-radio-group v-model="form.radio" v-else>
                       <el-radio-button  :label="index" size="medium">设为正确答案</el-radio-button>
                    </el-radio-group>
                    <i class="el-icon-close" @click="closeChoice(index)" v-if="form.radioData.length > 2"></i>
                    <span class="is-disabled" v-else>
                      <i class="el-icon-close"></i>
                    </span>

                </div>
           </el-form-item>
           <!--  多选-->
           <el-form-item  class="yk-radioChoice" v-if="numType == 2">
             <div class='clearfix'>
                <div class='lf'>
                  <span>选项</span>
                </div>
                <div class='rt'>
                  <el-form-item  v-show="numType == 1|| numType == 2">
                    <el-button type="primary" @click="addChoice(numType)" icon='el-icon-circle-plus-outline'>添加选项</el-button>
                  </el-form-item>
                </div>
             </div>
              <div class="yk-op-choice-child" v-for="(item,index) in form.radioData" :key="index+1">
                    <el-checkbox >{{indexArr[index]}}</el-checkbox>
                    <div class="yk-input-show">
                       <!-- <div style="position:absolute;right:0;top:0;width:100%;height:40px;border:1px solid black;"> -->
                         <Editor v-model="form.radioData[index]" :config="editorconfig"/>
                         <!-- <Editor v-model="form.radioData[index]" height="42px" isShowMenus="false"/> -->
                       <!-- </div> -->
                    </div>
                    <el-checkbox-group v-model="checkList" v-if='checkList.indexOf(index)>-1'>
                      <el-checkbox-button :label="index" @change="showAnswer()">正确答案</el-checkbox-button>
                    </el-checkbox-group>
                    <el-checkbox-group v-model="checkList" v-else>
                      <el-checkbox-button :label="index" @change="showAnswer()">设为正确答案</el-checkbox-button>
                    </el-checkbox-group>
                    <i class="el-icon-close" @click="closeChoice(index)" v-if="form.radioData.length > 2"></i>
              </div>

           </el-form-item>
           <!-- <el-form-item label="选项" class="yk-cb-con" v-if="numType == 2">
               <el-checkbox-group v-model="checkList" class="yk-check-group">
                   <div class="yk-cd-con-child" v-for="(item,index) in form.radioData" :key="index+1">
                        <el-checkbox :label="index" @change="showAnswer()">{{indexArr[index]}}</el-checkbox>
                        <el-input v-model="form.radioData[index]" placeholder="请输入内容"></el-input>
                        <i class="el-icon-close" @click="closeChoice(index)"></i>
                   </div>
               </el-checkbox-group>
           </el-form-item> -->
            <!-- 判断题 -->
           <el-form-item label='设定答案' class='yk-judge' v-if="numType == 3" >
               <div class="yk-correct-answer">
                 <el-radio-group  v-model="radioJudje">
                    <el-radio-button :label="1" size='medium'>对</el-radio-button>
                    <el-radio-button :label="0">错</el-radio-button>
                 </el-radio-group>
               </div>
           </el-form-item>
           <!-- 填空题 -->
           <el-form-item label="设定答案" v-if="numType == 4" class="yk-que-fillBlank">
                <el-form-item  v-show="numType == 4">
                    <el-button type="primary" @click="addChoice(numType)" icon='el-icon-circle-plus-outline'>添加新空项</el-button>
                    <el-checkbox v-model="isDisorder">是否乱序</el-checkbox>
                </el-form-item>
                <div class="yk-que-fillBlank-con yk-op-choice-child" 
                     v-for="(item,index) in form.blankData" :key="index+1" v-if=" form.blankData.length > 0">
                    <span>{{index + 1}}.</span>
                    <div v-for="(e,indexs) in item" :key="indexs">
                      <div class="yk-input-shows">
                          <Editor v-model="item[indexs]" :config="editorconfig"/>
                      </div>
                      <i class="el-icon-close" @click="clickDelete(index,indexs)"></i>
                    </div>
                    <span @click="options(index)" class="ti-options-class"> <i class="el-icon-circle-plus-outline"></i> 备选</span>
                    <!-- <span @click="options(index)" class="ti-options-class">备选：</span>
                    <div class="yk-input-shows" v-for="(e,index) in item.options"> -->
                        <!-- <el-input v-model="form.blankData[index]" :placeholder="'请输入填空项'+ (index+1) +'的标准答案'"></el-input> -->
                        <!-- <Editor v-model="item.options[index]" :config="editorconfig"/>
                    </div> -->

                    <i class="el-icon-close" @click="closeChoice(index)"></i>
                    <div style="color:#EE4166;font-size:13px;margin-left: 36px;height: 23px;line-height: 26px;" v-if="blankWarning">
                      <i class='el-icon-warning'></i>
                      题目中未找到匹配的填空项{{index+1}},请在检查一下项目</div>
                </div>

                <!-- <div v-if="form.blankData.length==0">
                  <div class="yk-fill-input">
                      <el-input :disabled="true"></el-input>
                  </div>
                </div> -->
                <!-- <div style="color:red;margin-left:10px;font-size:13px;" v-if="blankWarning">题目中未找到匹配的填空项+{{index}}+,请在检查一下项目</div> -->
           </el-form-item>

           <el-form-item v-show="numType == 4" class='yk-que-prompt'>
               <span>在题干中输入 ____（4个连续的下划线）或点击“添加新空项”，即可创建一个新的填空项</span>
           </el-form-item>

          <!-- <el-form-item label="正确答案" v-if="numType == 1 || numType == 2" >
               <div class="yk-correct-answer">
                   <span>{{correctAnswer}}</span>
               </div>
          </el-form-item> -->
            <!-- 简答题 -->
          <el-form-item label="设定答案" class='yk-short-answer' v-if="numType == 5" >
                <Editor v-model="referenceAnswer" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="解析" style="color: #222;"  v-if="numType != 6" class='yk-analysis'>
                <Editor v-model="analysisContent" placeholder="请输入内容"/>
          </el-form-item>
          <el-form-item label="解析附件" v-if="numType != 6" class='yk-attachment'>
                <QuestionFile ref="analysisFileList" :url="urlAliyunOSS" :fileIds.sync="analysisFileIds" :filesList="analysisFilesList" :files.sync="analysisFileList"></QuestionFile>
           </el-form-item>
          <!-- 综合题 -->
          <div v-for="(item,index) in chrildQuetion" :key="index+1" v-if="numType == 6">
            <SingleChoice ref="SingleChoice" v-if="item.QuestionType ==1" :showChoice='showChoice' :childQuestion='item' :iSubmit='iSubmit' :sortOrder='item.sortOrder' :index='index'  @done="submitChildQuestions" @remove="remove"></SingleChoice>
            <Multiselect ref="Multiselect" v-if="item.QuestionType == 2" :showChoice='showChoice' :childQuestion='item' :iSubmit='iSubmit' :sortOrder='item.sortOrder' :index='index'  @done="submitChildQuestions" @remove="remove"></Multiselect>
            <TrueFalse ref="TrueFalse" v-if="item.QuestionType == 3" :showChoice='showChoice' :childQuestion='item' :iSubmit='iSubmit' :sortOrder='item.sortOrder' :index='index'  @done="submitChildQuestions"  @remove="remove"></TrueFalse>
          </div>

          <el-form-item label="添加子题目"  v-if="numType == 6" class='yk-sub-topic'>
                <el-button @click='addChildQuestion(1)'>添加单选题</el-button>
                <el-button @click='addChildQuestion(2)'>添加多选题</el-button>
                <el-button @click='addChildQuestion(3)'>添加判断题</el-button>
          </el-form-item>
          <div class="yk-operate-btn">
                <!-- <el-button @click="formReset" class='yk-cancel'>取消</el-button> -->
                <el-button v-if="showButton!='true'" @click="formSubmitNewAndGo" type="primary">保存并继续</el-button>
                <el-button @click="formSubmitNew" type="primary" style='margin-right:0'>保存</el-button>
          </div>
       </el-form>
   </div>
</template>

<script>
import SingleChoice from 'components/ObjectiveTest/Question/SingleChoice.vue';
import Multiselect from 'components/ObjectiveTest/Question/Multiselect.vue';
import TrueFalse from 'components/ObjectiveTest/Question/TrueFalse.vue';
import { Message } from 'element-ui';
import { saveCombineQue } from 'api/v1.desgin.question.ts';
import QuestionFile from 'components/AliyunOSS/QuestionFile.vue';

export default {
  name: 'choice',
  components: {
    SingleChoice,
    Multiselect,
    TrueFalse,
    QuestionFile
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    courseId: {
      type: String,
      default: ''
    },
    childQuestionList: {
      type: Array,
      default: []
    },
    showChoice: {
      type: Boolean,
      default: false
    },
    valueEditor: {
      type: String,
      default: ''
    },
    stemFiles: {
      type: Array,
      default: []
    },
    analysisFile: {
      type: Array,
      default: []
    },
    showButton: {
      type: String,
      default: ''
    }
  },
  created() {
    this.filesList = this.stemFiles;
    this.analysisFilesList = this.analysisFile;
  },
  data() {
    return {
      isDisorder: false, // 是否乱序
      urlAliyunOSS: '/api/design/osssign/getsign',
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      editorconfig: {
        toolbarInline: true,
        charCounterCount: false,
        toolbarVisibleWithoutSelection: true,
        placeholderText: '',
        toolbarButtons: [
          'undo',
          'redo',
          'bold',
          'underline',
          'strikeThrough',
          'align',
          'insertLink',
          'insertImage'
        ],
        pluginsEnabled: ['image']
        // heightMin:100
      },
      form: {
        queType: [
          {
            value: 1,
            label: '单选题'
          },
          {
            value: 2,
            label: '多选题'
          },
          {
            value: 3,
            label: '判断题'
          },
          {
            value: 4,
            label: '填空题'
          },
          {
            value: 5,
            label: '简答题'
          },
          {
            value: 6,
            label: '综合题'
          }
        ],
        diffType: [
          {
            value: 1,
            label: '简单'
          },
          {
            value: 2,
            label: '一般'
          },
          {
            value: 3,
            label: '困难'
          }
        ],
        radio: -1, // 单选题题答案
        radioData: ['', '', '', ''], // 单选与多选的框
        blankData: [] // 填空题选项与答案
      },
      stemContent: '', // 题干
      referenceAnswer: '', // 简答题答案
      analysisContent: '',
      diffTypeValue: 1,
      indexArr: [
        'A.',
        'B.',
        'C.',
        'D.',
        'E.',
        'F.',
        'G.',
        'H.',
        'I.',
        'J.',
        'K.',
        'L.',
        'M.',
        'N.',
        'O.',
        'P.',
        'Q.',
        'R.',
        'S.',
        'T.',
        'U.',
        'V.',
        'W.',
        'X.',
        'Y.',
        'Z.'
      ],
      fbIndexArr: [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
      ],
      checkList: [], // 多选题答案
      correctAnswer: '',
      queDialogShow: false,
      radioJudje: 1, // 判断题题答案
      quetionId: '',
      numType: 1, // 题目类型,
      blankWarning: false,
      blankListLength: '',
      chrildQuetion: [],
      iSubmit: false,
      childQueInfo: [],
      isAdd: false
    };
  },
  computed: {
    auth() {
      let auth = this.$store.state.auth;
      return { ...auth };
    }
  },
  mounted() {
    this.setQuestionInfo();
  },
  watch: {
    'form.radio': function(val) {
      this.correctAnswer = this.indexArr[val];
    },
    checkList: function(val) {
      let answer = '';
      for (let i = 0; i < val.length; i++) {
        answer += this.indexArr[val[i]] + '；';
      }
      this.correctAnswer = answer;
    },
    data: function() {
      this.setQuestionInfo();
    },
    stemContent: function(val) {
      var exArray = val.substr(3).split('</p>');
      var blankArr = exArray[0].match(/_{4,}/g);
      var blankLength = blankArr ? blankArr.length : 0;
      this.blankListLength = blankLength;
      let arr = [];
      let list = [['']];
      debugger;
      if (blankLength >= 1) {
        for (let i = 0; i < blankLength; i++) {
          if (this.data) {
            arr[i] = this.data.Answers[i] ? this.data.Answers[i] : list[0];
          } else {
            arr[i] =  list[0] || ' ';
          }
        }
      }
      debugger;
      this.form.blankData.forEach((ele, index) => {
        if (arr.length > index) {
          arr[index] = ele;
        }
      });
      if(this.data){
        this.data.Answers = arr;
      }
      
      this.form.blankData = arr;
      if (blankLength !== this.form.blankData.length) {
        this.blankWarning = true;
      } else if (blankLength === this.form.blankData.length) {
        this.blankWarning = false;
      }
      // }
    },
    showChoice: function(val) {
      if (val) {
        this.chrildQuetion = this.childQuestionList;
      }
    },
    stemFiles: function(val) {
      let list = [];
      let ids = [];
      val.forEach(element => {
        list.push(element);
        ids.push(element.DocId);
      });
      this.filesList = list;
      this.fileList = list;
      this.fileIds = ids;
    },
    analysisFile: function(val) {
      let list = [];
      let ids = [];
      val.forEach(element => {
        list.push(element);
        ids.push(element.DocId);
      });
      this.analysisFilesList = list;
      this.analysisFileList = list;
      this.analysisFileIds = ids;
    }
  },
  methods: {
    clickDelete(index,indexs){
      if(this.form.blankData[index].length == 1){
        this.form.blankData.splice(index,1);

        // this.form.blankData.splice(index, 1);
        this.data.Answers.splice(index,1);
        var str = '';
        var strs = this.stemContent.split(/_{4,}/g);
        var exArray = this.stemContent.substr(3).split('</p>');
        var blankArr = exArray[0].match(/_{4,}/g);
        strs.forEach((ele, i) => {
          if (i === index || i === strs.length - 1) {
            str += ele;
          } else {
            str += ele + blankArr[i];
          }
        });
        this.stemContent = str;
        if (this.blankListLength !== this.form.blankData.length) {
          this.blankWarning = true;
        } else if (this.blankListLength === this.form.blankData.length) {
          this.blankWarning = false;
        }

      }else{
        this.form.blankData[index].splice(indexs,1);
      }
      
    },
    options(index){
      debugger;
      this.form.blankData[index].push('');
      console.log(this.form.blankData);
    },
    // 添加选项
    addChoice: function(numType) {
      // 根据题型来增加
      let numTypeIndex = numType;
      if (numTypeIndex === '') {
        Message.warning('请先选择题型');
      }
      // 单选题多选题添加
      if (numTypeIndex === 1 || numTypeIndex === 2) {
        let dataRadioCopy = this.form.radioData;
        let lengthAdd = dataRadioCopy.length;
        // if (lengthAdd === 7) {
        //   Message.warning('最多只能添加7个选项');
        //   return dataRadioCopy.splice(7, lengthAdd - 7);
        // }
        if(lengthAdd >= 26){
          let indexStr = this.indexArr[parseInt(lengthAdd/26)-1].substr(0,1) +this.indexArr[lengthAdd%26];
          this.indexArr.push(indexStr);
        }
        if(lengthAdd >= 702){
          Message.warning('最多只能添加702个选项');
        }
        this.form.radioData.push('');
      }
      if (numTypeIndex === 4) {
        // this.form.blankData.push('');
        this.stemContent = this.stemContent.indexOf('<p>') > -1 ? this.stemContent.substring(0, this.stemContent.length - 4) + ' ____</p>' : this.stemContent + '____';
      }
    },
    // 删除选项
    closeChoice: function(index) {
      if (this.numType === '') {
        Message.warning('未选择题型无法删除');
      }
      // 单选删除
      if (this.numType === 1) {
        this.form.radioData.splice(index, 1);
        if (this.form.radio === index) {
          this.form.radio = -1;
        } else if (this.form.radio > index) {
          this.form.radio = this.form.radio - 1;
        }
      }
      // 多选删除
      if (this.numType === 2) {
        let indexNum = this.checkList.indexOf(index);
        if (indexNum >= 0) {
          this.checkList.splice(indexNum, 1);
        } else {
          let list = [];
          for (let i = 0; i < this.checkList.length; i++) {
            if (this.checkList[i] > index) {
              list.push(this.checkList[i] - 1);
            } else {
              list.push(this.checkList[i]);
            }
          }
          this.checkList = list;
        }
        this.form.radioData.splice(index, 1);
      }
      // 填空删除
      if (this.numType === 4) {
        this.form.blankData.splice(index, 1);
        if(this.data){
          this.data.Answers.splice(index,1);
        }        
        var str = '';
        var strs = this.stemContent.split(/_{4,}/g);
        var exArray = this.stemContent.substr(3).split('</p>');
        var blankArr = exArray[0].match(/_{4,}/g);
        strs.forEach((ele, i) => {
          if (i === index || i === strs.length - 1) {
            str += ele;
          } else {
            str += ele + blankArr[i];
          }
        });
        this.stemContent = str;
        if (this.blankListLength !== this.form.blankData.length) {
          this.blankWarning = true;
        } else if (this.blankListLength === this.form.blankData.length) {
          this.blankWarning = false;
        }
      }
    },
    // 切换题型
    changeType: function(val) {
      this.correctAnswer = '';
      this.form.radio = -1; // 单选题题答案
      this.checkList = []; // 多选题答案
      // this.form.radioData = ['', '', '', '']; // 单选与多选的框
      this.form.blankData = []; // 填空题选项与答案
      // this.stemContent = ''; // 题干
      this.referenceAnswer = ''; // 简答题答案
      // this.analysisContent = '';
      this.radioJudje = 1; // 判断题题答案
      this.chrildQuetion = [];
    },
    // 保存后继续新增
    formSubmitNewAndGo: function() {
      let numIndex = this.numType;
      if (numIndex === '') {
        Message.warning('未选择题型无法提交');
      } else if (this.stemContent ===''){
        Message.warning('题干不能为空');
      }else if (this.chrildQuetion.length ===0 && numIndex === 6){
        Message.warning('子题目不能为空');
      }else {
        if (numIndex === 6) {
          this.submitChildQuestion(1);
          this.isAdd = true;
          this.childQueInfo = [];
        } else {
          this.formSubmit(true);
        }
      }
    },
    // 保存题目
    formSubmitNew: function() {
      let numIndex = this.numType;
      // if(numIndex === 6){

      // }
      if (numIndex === '') {
        Message.warning('未选择题型无法提交');
      }else if (this.stemContent ===''){
        Message.warning('题干不能为空');
      }else if (this.chrildQuetion.length ===0 && numIndex === 6){
        Message.warning('子题目不能为空');
      }else {
        if (numIndex === 6) {
          this.submitChildQuestion(1);
          this.isAdd = false;
        } else {
          this.formSubmit(false);
        }
        // this.$router.push({
        //   name: 'QuestionWarehouse',
        //   params: {
        //     courseId: this.courseId
        //   }
        // });
      }
    },
    // 传递给父组件的数据
    formSubmit: function(isAdd) {
      let numIndex = this.numType;
      if (numIndex === '') {
        Message.warning('未选择题型无法提交');
      }
      let correctAnswerArray = [];

      let selectArray = [];
      this.setCorrectArray(numIndex, correctAnswerArray, selectArray);

      this.$emit('newNodeEvent', {

        questionId: this.quetionId,
        quesType: this.numType,
        diffcult: this.diffTypeValue,
        content: this.stemContent,
        selects: selectArray,
        correctAnswers: correctAnswerArray,
        analysis: this.analysisContent,
        isAdd: isAdd,
        fileIds: this.fileIds,
        analysisFileIds: this.analysisFileIds,
        answersIsDisorder: this.isDisorder
      });
    },
    setCorrectArray: function(type, answers, selects) {
      switch (type) {
        case 1:
          answers.push(this.form.radio);
          this.form.radioData.forEach(element => {
            selects.push(element);
          });
          break;
        case 2:
          this.checkList.forEach(element => {
            answers.push(element);
          });
          this.form.radioData.forEach(element => {
            selects.push(element);
          });
          break;
        case 3:
          answers.push(this.radioJudje);
          break;
        case 4:
          this.form.blankData.forEach(element => {
            answers.push(element);
          });
          break;
        case 5:
          answers.push(this.referenceAnswer);
          break;
        default:
          break;
      }
    },
    formReset: function() {
      this.$emit('closeDialog', this.queDialogShow);
      this.cleanData();
      this.numType = 1;
      this.diffTypeValue = 1;
    },
    // 排序
    showAnswer: function(index) {
      this.checkList.sort();
    },
    // changeAnswer: function(index) {
    //   let isAdd = true;
    //   this.checkList.forEach(function(item, i) {
    //     if (this.indexArr[index] === item) {
    //       isAdd = false;
    //     }
    //   });
    // },
    // 赋值
    setQuestionInfo() {
      debugger;
      this.cleanData();
      this.numType = 1;
      this.diffTypeValue = 1;
      if (this.data) {
        this.chrildQuetion = this.childQuestionList;
        this.numType = parseInt(this.data.QuestionType);
        this.diffTypeValue = parseInt(this.data.Difficulty);
        this.quetionId = this.data.Id;
        this.stemContent = this.data.Content;
        this.analysisContent = this.data.Analysis;
        this.isDisorder = this.data.AnswersIsDisorder;
        if(this.numType==1||this.numType==2){
          let selectLength = this.data.Selects.length;
          if(selectLength > 26){
            for(let i= 0;i < selectLength-26;i++){
              let indexStr = this.indexArr[parseInt(i/26)].substr(0,1) +this.indexArr[i%26];
              this.indexArr.push(indexStr);
            }
          }
        }
        this.gettCorrectArray(
          this.numType,
          this.data.Selects,
          this.data.Answers
        );
      }
    },
    handle(val){
      debugger;
      return val.split('或');
    },
    gettCorrectArray: function(type, selects, answers) {
      switch (type) {
        case 1:
          this.form.radio = parseInt(answers[0]);
          this.form.radioData = selects;
          break;
        case 2:
          answers.forEach(element => {
            this.checkList.push(parseInt(element));
          });
          this.form.radioData = selects;
          break;
        case 3:
          this.radioJudje = parseInt(answers[0]);
          break;
        case 4:
          debugger;
          var list =[];
          for(let i = 0; i<=answers.length;i++){
            debugger;
            list = answers.map(this.handle)
          }
          console.log(list);
          this.form.blankData = list;
          break;
        case 5:
          this.referenceAnswer = answers[0];
          break;
        default:
          break;
      }
    },
    // 清空数据
    cleanData: function() {
      this.form.radio = -1; // 单选题题答案
      this.form.radioData = ['', '', '', '']; // 单选与多选的框
      this.form.blankData = []; // 填空题选项与答案
      this.stemContent = ''; // 题干
      this.referenceAnswer = ''; // 简答题答案
      this.analysisContent = '';
      // this.diffTypeValue = 1;
      this.checkList = []; // 多选题答案
      this.correctAnswer = '';
      this.queDialogShow = false;
      this.radioJudje = 1; // 判断题题答案
      this.quetionId = '';
      // this.numType = 1; // 题目类型
      this.iSubmit = false;
      this.filesList = [];
      this.analysisFilesList = [];
    },
    addChildQuestion: function(type) {
      let que = this.chrildQuetion;
      let sortOrder = que.length;
      this.chrildQuetion.push({
        QuestionType: type,
        sortOrder: sortOrder,
        radioData: ['', '', '', ''],
        radio: type==3?['1']:['']
      });
    },
    submitChildQuestion: function(obj) {
      this.iSubmit = true;
    },
    submitChildQuestions: function(obj) {
      var that = this;
      this.childQueInfo.push({
        Content: obj.form.questionTitle,
        Type: obj.form.QuestionType,
        Difficult: 1,
        Selects: obj.form.radioData,
        CorrectSelect: obj.form.radio,
        Analysis: obj.form.analysisContent,
        SortOrder: obj.form.sortOrder
      });
      if (this.childQueInfo.length === this.chrildQuetion.length) {
        var msg = "";
        this.childQueInfo.forEach((ele,index) =>{
          if(ele.Content=="" && msg != ""){
            msg = "第"+index+"小题题干为空";
          }else if(ele.CorrectSelect.length == 0 || ele.CorrectSelect[0] == '1' && msg != ""){
            msg = "第"+index+"小题未设置答案";
          }
        });
        if(msg!=""){
           this.$message.warning(msg);
        }else{
          saveCombineQue(
            this.stemContent,
            this.valueEditor,
            parseInt(this.diffTypeValue),
            JSON.stringify(this.childQueInfo),
            this.courseId,
            this.fileIds,
            this.quetionId
          ).then(rst => {
            this.$message.success('添加成功');
            this.$emit('done', {
              pageIndex: 1,
              isAdd: this.isAdd
            });
            this.cleanData();
            this.numType = 1;
            this.diffTypeValue = 1;
            if(!that.isAdd){
              console.log(this.auth.userType);
            if (this.auth.userType == 2) {
                this.$router.push({
                name: "QuestionWarehouse",
                params: {
                  courseId: this.courseId
                }
              });
            } else {
              this.$router.push({
                name:"teaShareManagementQuestion",
                params: {
                  courseId: this.courseId
                }
              })
            }
            }
          });
        }

        // saveCombineQue(
        //   this.stemContent,
        //   this.valueEditor,
        //   parseInt(this.diffTypeValue),
        //   JSON.stringify(this.childQueInfo),
        //   this.courseId,
        //   this.fileIds,
        //   this.quetionId
        // ).then(rst => {
        //   this.$message.success('添加成功');
        //   this.$emit('done', {
        //     pageIndex: 1,
        //     isAdd: this.isAdd
        //   });
        //   this.cleanData();
        //   this.numType = 1;
        //   this.diffTypeValue = 1;
        // });
      }
    },
    remove: function(val) {
      this.chrildQuetion.splice(val, 1);
    }
  }
};
</script>

<style lang="scss">
.yk-choice-question {
  .yk-question {
    display: flex;
    margin-top:-1px;
    .yk-question-type{
      position: absolute;
      right: 190px;
      top:0;
      .el-form-item__label{
        padding:0;
        font-size: 16px;
        color:#000;
      }
    }
    .yk-difficulty{
      position: absolute;
      right: 10px;
      top:0;
      .el-form-item__label{
        padding:0;
        font-size: 16px;
        color:#000;
      }
    }
    .yk-question-type,.yk-difficulty{
    .el-form-item__label{
      color:#000;
      width:60px !important;
    }
    .el-form-item__content{
      margin-left: 60px !important;
      .el-input__inner{
        color:#ccc;
        border:1px solid #e6e6e6;
        width:120px;
        background:#fff;
      }
    }
  }
  }
  .yk-title{
    border:0 !important;
    .el-form-item__label{
      width: 100% !important;
      display: block;
      text-align: left;
      margin-top: 37px;
      border-top: 1px solid #ccc;
      padding-top: 7px;
      color:#000;
    }
  }
  .yk-single-con{
    position: relative;
    .yk-add-item{
      position: absolute;
      right: 21px;
      top: 167px;
      .el-button{
        color: #fff;
        background-color: #409EFF;
        border-color: #409EFF;
        font-size: 14px;
      }
    }
    .yk-radioChoice{
      width:100%;
      margin-bottom:0;
      margin-top: 20px;
      .el-form-item__content{
        .el-form-item{
          margin-bottom: 10px;
          .el-form-item__content{
            .el-checkbox{
              width:3%;
              .el-checkbox__input{
                display: none;
              }
              .el-checkbox__label{
                font-size: 18px;
                color:#000;
                padding-left:0;
              }
            }
            .el-checkbox-group{
              display: inline-block;
              vertical-align: bottom;
              .is-checked{
                .el-checkbox-button__inner {
                    background: #409EFF;
                }
              }
              .el-checkbox-button__inner{
                border-radius: 0px 4px 4px 0px;
                background: #409EFF;
                color: #fff;
                width: 110px;
                height:40px;
                border:0;
                line-height:40px;
                padding:0;
              }
            }
            .yk-input-show{
              width: 90%;
              .el-input{
                width:100%;
                margin-left:0;
                .el-input__inner{
                  height:40px;
                  border-radius: 4px 0 0 4px;
                  color:#ccc;
                  background:#fff;
                }
                .el-input-group__append{
                  padding:0;
                  border:0;
                  background-color: #3F5880
                }
              }
            }
            .el-icon-close{
              width:16px;
              height:16px;
              background:#EE4166;
              color: #fff;
              border-radius: 50%;
              vertical-align: middle;
              text-align: center;
              margin-left:30px;
            }
          }
        }
      }
    }
    .yk-multiselect-delete{
      position: absolute;
      top: 0;
      right: 21px;
      .el-button{
        background-color: #EE4166;
        border-color: #EE4166;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .yk-truefalse{
    position: relative;
    .yk-truefalse-delete{
      position: absolute;
      top: 6px;
      right: 21px;
      .el-button{
        background-color: #EE4166;
        border-color: #EE4166;
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .yk-title,.yk-analysis,.yk-short-answer,.yk-single-con,.yk-truefalse-title,.yk-single-choice{
    border-top:1px solid #ccc;
    margin:0;
    padding:7px 0 20px 0;
    .el-form-item__label{
      float:none;
      font-size:16px;
      color:#000;
    }
    .el-form-item__content{
      margin-left:0 !important;
      .fr-toolbar{
        border:0;
        background: #fff;
        .fr-command.fr-btn, .fr-popup .fr-command.fr-btn{
          color:#000
        }
      }
      .fr-wrapper{
        background: #fff;
        border: 1px solid #fff;
        .fr-element p{
          color:#000
        }
      }
    }
  }
  .yk-attachment{
    border-top:1px solid #ccc;
    margin:0;
    padding-top:7px;
    .el-form-item__label{
      font-size: 16px;
      color:#000;
      text-align: left;
    }
    .el-form-item__content{
      float:right;
      width: 100%;
      .el-upload{
        // float: right;
        position: absolute;
        top: -38px;
        right: 24px;
      }
      .wl-icon-shangchuan{
        margin-right:5px
      }
      .el-upload-list{
        float: left;
        background: #dde4eb;
        width: 100%;
        border-radius: 4px;
        margin-bottom:20px;
        .el-upload-list__item{
          margin:0;
          padding: 6px 0;
          background: #dde4eb;
          padding-left: 18px;
          height: 40px;
          line-height: 40px;
          .el-upload-list__item-name{
            color:#000;
            padding-left: 0;
            line-height: 40px;
            padding: 0;
            position: absolute;
            top: 0;
            .el-icon-document::before{
              color:#000
            }
            i{
              direction: block !important;
              font-size: 20px;
              line-height: 1;
              position: absolute;
              left: 56px;
              top: 10px;
            }
          }
          .el-upload-list__item-thumbnail{
            display: none;
          }
          .el-upload-list__item-status-label{
            top: 8px;
            right:30px;
            border: 0.5px solid #409EFF;
            background: #dde4eb;
            width: 15px;
            height: 15px;
            border-radius: 100%;
            .el-icon-upload-success{
              color:#409EFF;
              position: absolute;
              right: 2px;
              top: -11px;

            }
          }
          .el-icon-close{
              width: 13px;
              height: 13px;
              border-radius: 50%;
              background: #EE4166;
              color: #fff;
              top: 13px;
              right:30px;
              font-size: 10px;
              line-height: 14px;
              text-align: center;
            }
            .el-icon-close-tip{
              display: none
            }
        }
      }
      // .el-button--primary {
      //     color: #409EFF;
      //     background-color: #374256;
      //     border-color: #374256;
      //     font-size:14px
      // }
    }
  }
  .yk-radioChoice {
    // .el-form-item__label{
    //   float:none;
    //   color:#ffffff;
    //   font-size:16px;
    // }
    margin-bottom:12px;
    border-top:1px solid #ccc;
    margin-top: 20px;
    // margin-top:21px;
    .el-form-item__content{
      margin-left:0 !important;
      .clearfix{
        margin: 20px 0;
        .lf{
          float:left;
          color:#000;
          font-size:16px;
        }
        .rt{
          float:right;
          margin-right: 24px;
          .el-form-item{
            .el-form-item__content{
              // .el-button--primary{
              //     color: #409EFF;
              //     background-color: #374256;
              //     border-color: #374256;
              //     font-size: 14px;
              //     padding:0 15px
              // }
            }
          }
        }
      }
      .yk-op-choice-child {
        // margin-top: 10px;
        margin-bottom:10px;
        .el-radio,.el-checkbox{
          width: 3%;
          .el-radio__inner,.el-checkbox__inner{
            display:none;
          }
          .el-radio__label,.el-checkbox__label{
            padding:0 14px 0 0;
            width:15px;
            height:14px;
            font-size:18px;
            font-family:SourceHanSansSC-Regular;
            font-weight:400;
            color:#000;
          }
        }
        label,
        .yk-input-show,
        i {
          display: inline-block;
        }
        .yk-input-show {
          width: calc(100% - 260px);
          background: #fff;
          border: 1px solid #ccc;
          padding: 5px 10px;
          color: #000;
          border-radius: 4px 0 0 4px;
          line-height: 28px;
        }
        .el-checkbox-group{
          display: inline-block;
          vertical-align: bottom;
          .is-checked{
            .el-checkbox-button__inner{
              background: #409EFF;
            }
          }
          .el-checkbox-button__inner{
            border-radius: 0px 4px 4px 0px;
            background: #409EFF;
            color: #000;
            border:0;
            width:110px;
            height:40px;
            line-height: 40px;
            padding:0;
          }
        }

        .el-radio-group{
          vertical-align: bottom;
          .is-active{
            .el-radio-button__inner{
              background: #409EFF
            }
          }
          .el-radio-button__inner{
            border-radius: 0px 4px 4px 0px;
            background: #409EFF;
            color: #ffffff;
            border:0;
            font-size: 14px;
            width:110px;
            height:40px;
            padding: 0;
            line-height: 40px;
          }
        }
        .el-icon-close{
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background: #EE4166;
            text-align: center;
            line-height: 16px;
            margin-left: 30px;
            color: #fff;
            cursor: pointer;
        }
      }
    }

  }
  .yk-judge{
    border-top: 1px solid #ccc;
    padding-top: 9px;
    // margin-top: 21px;
    .el-form-item__label{
      float:none;
      color: #000;
      font-size: 16px;
    }
    .el-form-item__content{
      margin-left:0 !important;
      .el-radio-button{
        border-radius:4px;
        margin-right:30px;
        .el-radio-button__inner{
          width: 100px;
          height: 40px;
          border-radius: 4px;
          background: #409EFF;
          color: #ffffff;
          border: 0;
        }
      }
      .is-active{
        .el-radio-button__inner{
          background: #409EFF
        }
      }
    }
  }
  .yk-single-choice{
    position:relative;
    .yk-radioChoice{
      .el-form-item__content{
        .yk-input-show-single{
          width:90%;
          display: inline-block;
          .el-input__inner{
            height:40px;
            border-radius: 4px 0 0 4px;
            color:#000;
            background:#fff;
          }
          .el-input-group__append{
            padding:0;
            border:0;
            background-color: #3F5880
          }
        }
      }
    }
    .yk-add-item{
      position:absolute;
      top:167px;
      right:21px;
      .el-button{
        background: #409EFF;
        border:0;
        color: #fff;
      }
    }
    .yk-single-delete{
      position:absolute;
      top:3px;
      right:21px;
      .el-form-item__content{
        .el-button{
          background: #EE4166;
          border: 0;
          font-size: 14px;
          color: #fff;
        }
      }
    }
  }
  .yk-cb-con {
    .yk-check-group {
      .yk-cd-con-child {
        display: flex;
        margin-top: 5px;
        .el-input {
          margin: 0 5px;
          display: block;
          width: 550px;
        }
      }
      .el-icon-close {
        margin-top: 10px;
        font-size: 15px;
      }
    }
  }
  .yk-operate-btn {
    border-top: 1px solid #ccc;
    padding-top: 21px;
    // margin-top:21px;
    display: flex;
    justify-content: flex-end;
    .yk-cancel{
      background: #374256;
      border: 1px solid #409EFF;
      color: #409EFF;
    }
    button {
      margin-right: 25px;
    }
  }
  .yk-que-fillBlank {
    border-top: 1px solid #ccc;
    // margin-top: 21px;
    padding-top: 8px;
    .el-form-item__label{
      float:none;
      color:#ffffff;
      font-size: 16px;
    }
    .el-form-item__content{
      margin-left:0 !important;
      .el-form-item{
        .el-form-item__content{
          position: absolute;
          top: -38px;
          right: 21px;
          .el-button{
            background: #409EFF;
            border-color: #409EFF;
            color: #fff;
          }
        }
      }
    }
    .yk-que-fillBlank-con {
      margin-top: 5px;
      span,
      .yk-fill-input,
      i {
        display: inline-block;
      }
      span {
        // margin-left: 10px;
        // color: gray;
        font-size: 18px;
        color: #000;
        width:3%;
      }
      .yk-fill-input {
        // margin-left: 10px;
        // width: 560px;
        width:90%;
        .el-input__inner{
          height:40px;
          color:#ccc;
          background:#fff;
        }
      }
      .el-icon-close{
        width: 16px;
        height: 16px;
        background: #EE4166;
        color: #fff;
        border-radius: 50%;
        line-height: 16px;
        text-align: center;
        margin-left:30px;
      }
      .yk-input-show{
        width:calc(100% - 210px);
        background: #fff;
        border: 1px solid #ccc;
        padding: 5px 10px;
        color: #000;
        border-radius: 4px 0 0 4px;
        display: inline-block;
      }
      .yk-input-shows{
        width:300px;
        background: #fff;
        border: 1px solid #ccc;
        color: #000;
        border-radius: 4px 0 0 4px;
        display: inline-block;
      }
      .ti-options-class{
        width: 5%;
        font-size: 14px;
        margin-left: 5px;
        cursor: pointer;
      }
    }
    .el-checkbox, .el-checkbox-button__inner{
      color: #000;
    }
  }
  .yk-que-prompt{
    position: absolute;
    top: 63px;
    right: 3px;
    color: #409EFF;
    font-size: 14px
  }
  .yk-sub-topic{
    border-top: 1px solid #4F6280;
    padding-top: 8px;
    .el-form-item__label{
      float:none;
      font-size:16px;
      color:#ffffff;
    }
    .el-form-item__content{
      margin-left:0 !important;
      .el-button{
        background: #409EFF;
        color: #ffffff;
        border: 0;
      }
      .el-button:active {
          color: #ffffff;
          border-color: #409EFF;
          outline: 0;
      }
      .el-button:focus, .el-button:hover {
          color: #ffffff;
          border-color: #c6e2ff;
          background-color: #409EFF;
      }
    }
  }
  .is-disabled{
    .el-icon-close{
        width:16px;
        height:16px;
        background:#ccc !important;
        border-radius: 50%;
        vertical-align: middle;
        text-align: center;
        margin-left:30px;
    }
  }
}
.yk-choice-question-s-new {
  .el-checkbox-group {
    font-size: 15px;
    color: #000000;
  }
  .el-select .el-input .el-select__caret{
    color:#409EFF
  }
}
</style>

